module.exports = __webpack_public_path__ + "img/qrcode_for_gh_6f36dbdb76b5_258.c0f91b44.jpg";